import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  mobileQuestionLabel: {
    backgroundColor: "#0071ce",
    fontSize: 16,
    color: "white",
    margin: "0 -5.5%",
    // paddingLeft: 17,
    // height: 30,           // Fixed height creating issue on mobile
    padding: "2px 2px 2px 17px",
    display: "flex",
    alignItems: "center",
    fontWeight: "normal",
  },
  mobileOptionWrapper: {
    display: "flex",
    justifyContent: "space-between",
    textAlign: "center",
    margin: "8px 0",
  },
  mobileOptionLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    textAlign: "left",
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineBreak: "strict",
  },
  desktopTableContainer: {
    overflowX: "scroll",
  },
  desktopTableCellHeader: {
    border: "none",
    textAlign: "center",
    fontWeight: "500",
    fontSize: 16,
    padding: 8,
    color: "#3b3b3b",
    width: "100px !important",
    verticalAlign: "bottom",
  },
  desktopTableCellQuestion: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: "white",
    border: "none",
    textAlign: "left",
    fontWeight: "500",
    paddingLeft: 0,
    paddingRight: 8,
    fontSize: 16,
    width: "145px !important",
  },
  desktopTableCellBody: {
    border: "none",
    textAlign: "center",
    fontSize: 16,
  },
  selectedRadio: {
    color: (props) => `${props.currentTheme.primaryColor} !important`,
  },
  elementStyle: {
    marginLeft: "-15px",
    "& svg": {
      height: "24px",
    },
    // color: (props) => `${props.currentTheme.primaryColor} !important`,
  },
  radioContainer: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "15px",
  },
  globalTech: {
    color: "#041f41 !important",
  },
  walmartClassic: {
    color: "#0071ce !important",
  },
  samClub: {
    color: "#0266A0 !important",
  },
  elementStyleNotSelected: {
    marginLeft: "-15px",
    "& svg": {
      height: "24px",
    },
    color: `#5E5E5E !important`,
  },
  headingStyle: {
    fontWeight: "normal",
  },
});

export default useStyles;
